export default __webpack_public_path__ + "static/media/20.c5a33ced.png";